import {Fragment} from 'react';

import {splitBeforeAllCapsHeaders} from '../utils/splitBeforeAllCapsHeaders';

interface TextWithNewLinesProps {
  text: string;
}

/**
 * Cebia workspace product requirement: the audit comment comes back as one
 * blob with uppercase section headers (KAROSERIA :, WNĘTRZE :, TECHNIKA :, …)
 * inlined mid-text. We split before each such header so the rendered comment
 * matches the underlying section structure.
 */
export function TextWithNewLines(props: TextWithNewLinesProps) {
  const lines = splitBeforeAllCapsHeaders(props.text);

  return (
    <div>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && (
            <>
              <br />
              <br />
            </>
          )}
        </Fragment>
      ))}
    </div>
  );
}
